"use client";

import { useState } from "react";

import { PAGE_TYPES } from "@/lib/briefing";
import type { PromptTopic } from "@/lib/api/types";
import { clusterKeyword } from "@/lib/prompt-module";

type Props = {
  topic: PromptTopic;
  tag: string;
  /** Prompts des Clusters ohne verworfene. */
  count: number;
  busy: boolean;
  error: string | null;
  onStart: (request: { keyword: string; pageType: string }) => void;
  onCancel: () => void;
};

const FIELD = "h-11 rounded-md border border-field bg-white px-3 text-sm";

/** Rückfrage vor „Briefing starten“: Haupt-Keyword (Vorschlag aus Topic und Cluster) und Seitentyp. Kostenlos. */
export function BriefingDialog({ topic, tag, count, busy, error, onStart, onCancel }: Props) {
  const [keyword, setKeyword] = useState(() => clusterKeyword(topic.name, tag));
  const [pageType, setPageType] = useState("ratgeber");
  const valid = keyword.trim().length > 0;

  return (
    <div
      role="group"
      aria-label="Briefing starten bestätigen"
      className="flex flex-col gap-3 rounded-lg border border-line bg-white px-5 py-4 text-sm"
    >
      <h2 className="text-base font-semibold">Briefing zum Cluster „{tag}“ starten?</h2>
      <p className="max-w-3xl text-[13px] text-muted">
        Es entsteht ein Briefing-Entwurf. In Schritt 2 sind die {count} {count === 1 ? "Prompt" : "Prompts"} des Clusters (ohne verworfene) schon als
        eigene Prompts gewählt, bis zum Limit von 10, die übrigen Vorschläge füllen auf. Keywords, Fan-outs, Quellen und Outline entstehen im
        Briefing wie gewohnt. Der Entwurf selbst kostet nichts, die Schritte zeigen ihre Kosten vor dem Start.
      </p>
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex flex-col gap-1">
          <label htmlFor="briefing-keyword" className="text-[13px] font-medium">
            Haupt-Keyword
          </label>
          <input
            id="briefing-keyword"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            className={`${FIELD} w-80 max-w-full`}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="briefing-page-type" className="text-[13px] font-medium">
            Seitentyp
          </label>
          <select id="briefing-page-type" value={pageType} onChange={(event) => setPageType(event.target.value)} className={FIELD}>
            {PAGE_TYPES.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {error && (
        <p role="alert" className="text-[13px] text-danger">
          {error}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          disabled={busy || !valid}
          onClick={() => onStart({ keyword: keyword.trim(), pageType })}
          className="h-11 rounded-md bg-accent px-3.5 text-sm font-medium text-white disabled:opacity-60"
        >
          {busy ? "Wird angelegt …" : "Briefing anlegen"}
        </button>
        <button type="button" onClick={onCancel} className="h-11 rounded-md border border-field bg-white px-3.5 text-sm">
          Abbrechen
        </button>
      </div>
    </div>
  );
}
